module.exports = __webpack_public_path__ + "static/media/conway-image.f7e3487f.PNG";